import React, { useState, useEffect } from 'react';
import { Col, Container, InputGroup, Row } from 'react-bootstrap';
import AddButton from 'src/Admin/components/User/UserFormNew/components/AddButton';
import FilterModal from 'src/Admin/components/common/filter-modal/FilterModal';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import TextInput from 'src/Components/GenericInputText/TextInput';
import List from './List';

const Location = ({ blobData, dispatch, setBlobData, fetchData }) => {
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [searchLocationText, setSearchLocationText] = useState('');
  const [locationDataLocal, setLocationDataLocal] = useState({});

  const [openLocationModalForRange, setOpenLocationModalForRange] =
    useState(false);
  const [searchLocationTextFrom, setSearchLocationTextFrom] = useState('');
  const [searchLocationTextTo, setSearchLocationTextTo] = useState('');

  useEffect(() => {
    setLocationDataLocal(blobData);
  }, []);

  const selectChangeHandler = (e) => {
    const { name, checked, id } = e.target;
    const tempBlob = blobData?.allLocationData?.map((blob) =>
      blob?.oid === id
        ? { ...blob, isChecked: true }
        : { ...blob, isChecked: false },
    );
    setLocationDataLocal({
      ...locationDataLocal,
      allLocationData: tempBlob,
      selectedLocationData: tempBlob?.filter(
        (item) => item?.isChecked === true,
      )[0],
    });
  };

  return (
    <div>
      <div className="heading-container">
        <span className="blob-heading">Location(s)</span>
        <span className="blob-data">
          (
          {blobData?.selectedEmployerData?.oid ? '1 Location' : 'All Locations'}
          )
        </span>
      </div>
      {!blobData?.selectedLocationData?.oid && (
        <div className="block-of-business-container">
          <div className="flex-1">
            <AddButton
              onClick={() => setOpenLocationModal(true)}
              className={'add-button-active reports-blob-button'}
              label="Select Location by name or ID"
            />
          </div>
          <span className="or-saperator">OR</span>
          <div className="flex-1">
            <AddButton
              onClick={() => {
                setOpenLocationModalForRange(true);
              }}
              className={'add-button-active reports-blob-button'}
              label="Select a Range"
            />
          </div>
        </div>
      )}
      <FilterModal
        showBackButton={false}
        isVisible={openLocationModal || openLocationModalForRange}
        onHide={() => {
          setSearchLocationText('');
          setOpenLocationModal(false);

          setSearchLocationTextFrom('');
          setSearchLocationTextTo('');
          setOpenLocationModalForRange(false);
        }}
        applyFilterHandler={() => {
          if (openLocationModal) {
            dispatch(
              setBlobData({
                locationType: 'single',
                allLocationData: locationDataLocal?.allLocationData,
                selectedLocationData:
                  locationDataLocal?.allLocationData?.filter(
                    (item) => item?.isChecked === true,
                  )[0],
              }),
            );
            setOpenLocationModal(false);
          } else if (openLocationModalForRange) {
            dispatch(
              setBlobData({
                locationType: 'range',
                allLocationData: [],
                selectedLocationData: {
                  from: searchLocationTextFrom,
                  to: searchLocationTextTo,
                },
              }),
            );
            setOpenLocationModalForRange(false);
          }
        }}
        showCancel={true}
        titleLabel="Location(s)"
        showApply={true}
        showApplyLabel={openLocationModal ? 'Add Selected' : 'Add Range'}
        customClasses="reports-blob-modal"
      >
        <Container className="mt-3 mb-3">
          {openLocationModal ? (
            <>
              <Row>
                <Col sm={12}>
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="Location"
                      append={
                        <InputGroup.Text>
                          <SearchSVG.SearchSVG className="primary-text-color" />
                        </InputGroup.Text>
                      }
                      inputProps={{
                        type: 'text',
                        placeholder: 'Search by name or description',
                        value: searchLocationText,
                        onChange: (e) => {
                          setSearchLocationText(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="mb-1">
                  <List
                    //data={blobDataLocal?.allBlobData?.length > 0 ?  blobDataLocal?.allBlobData : blobData?.allBlobData}
                    selectChangeHandler={selectChangeHandler}
                    displayId="oid"
                    displayLabel="LocationName"
                    labelIdText="Client ID"
                    rightValueForLocationDisplayID="ClientId"
                    searchString={searchLocationText}
                    modalFor="location"
                    fetchData={fetchData}
                    hasDescriptionText={true}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col sm={12} className="mt-3">
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="From Location ID"
                      inputProps={{
                        type: 'text',
                        placeholder: 'Example: 87890',
                        value: searchLocationTextFrom,
                        onChange: (e) => {
                          setSearchLocationTextFrom(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
                <Col sm={12} className="mt-3">
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="To Location ID"
                      inputProps={{
                        type: 'text',
                        placeholder: 'Example: 87890',
                        value: searchLocationTextTo,
                        onChange: (e) => {
                          setSearchLocationTextTo(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </FilterModal>
    </div>
  );
};

export default Location;
